import PropTypes from 'prop-types'
import { useState, useEffect } from 'react';
import { FormHelperText, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import MarkdownEditor, { commands as mdCommands } from '@uiw/react-md-editor';

import { updateTerms } from 'services/requests/terms';
import { toast } from 'utils';

export default function TermsForm({ defaultValues, type }) {
  document.documentElement.setAttribute('data-color-mode', 'light')

  const [content, setContent] = useState('')
  const [invalidContent, setInvalidContent] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = () => {
    if (!content) {
      setInvalidContent('Obrigatório')
      return false
    }

    setIsSubmitting(true)

    updateTerms({
      body: {
        content,
        type
      }
    })
      .then(() => toast('Termos atualizados com sucesso', 'success'))
      .catch((err) => toast(err, 'error'))
      .finally(() => setIsSubmitting(false));
  }

  useEffect(() => {
    setInvalidContent(null)
  }, [content])

  useEffect(() => {
    setContent(defaultValues?.content || '')
  }, [defaultValues])

  return (
    <>
      <Stack spacing={3} mt={2}>
        <MarkdownEditor
          value={content}
          onChange={value => setContent(value)}
          height="600px"
          extraCommands={[mdCommands.codeEdit, mdCommands.codeLive, mdCommands.codePreview]}
        />
        {
          invalidContent ? (
            <FormHelperText error sx={{ textAlign: 'right' }}>
              { invalidContent }
            </FormHelperText>
          ) : null
        }
      </Stack>

      <Stack direction="column" alignItems="end" justifyContent="end">
        <LoadingButton
          size="large"
          type="submit"
          color="secondary"
          variant="contained"
          onClick={() => handleSubmit()}
          loading={isSubmitting}
          sx={{ my: 2 }}
        >
          Salvar
        </LoadingButton>
      </Stack>
    </>
  );
}

TermsForm.propTypes = {
  defaultValues: PropTypes.object,
  type: PropTypes.string,
}
